<template>
  <div class="" style="padding:10px;background-color: #e9e9e9">
    <Select v-model="d_rent" style="width: 100px;margin-right:10px;" >
      <Option v-for="item in d_rent_data" :value="item.value">{{ item.label }}</Option>
    </Select>
    <Select v-model="d_shops" style="width: 100px;margin-right:10px;" >
      <Option v-for="item in d_shops_data" :value="item.value">{{ item.label }}</Option>
    </Select>
    <Select v-model="d_trade" style="width: 100px;margin-right:10px;">
      <Option v-for="item in d_trade_data" :value="item.value">{{ item.label }}</Option>
    </Select>
    <Select v-model="d_size" style="width: 100px;margin-right:10px;">
      <Option v-for="item in d_size_data" :value="item.value">{{ item.label }}</Option>
    </Select>
    <Select v-model="d_use" style="width: 100px;margin-right:10px;">
      <Option v-for="item in d_use_data" :value="item.value">{{ item.label }}</Option>
    </Select>
    <Button type="primary" @click="search()">查询</Button>
  </div>
</template>

<script>
  export default {
    name: 'searchShop',
    data(){
      return{
        d_rent: '1',//筛选条件开始
        d_rent_data: [
          {
            label: '未租',
            value: '1'
          },{
            label: '已租',
            value: '2'
          }
        ],
        d_shops: '1',
        d_shops_data: [
          {
            label: '社区商铺',
            value: '1'
          },{
            label: '商业街商铺',
            value: '2'
          },{
            label: '市场类商铺',
            value: '3'
          },{
            label: '住宅底层商铺',
            value: '4'
          },{
            label: '百货商场，购物中心商铺',
            value: '5'
          },{
            label: '商务楼，写字楼商铺',
            value: '6'
          },{
            label: '交通设施商铺',
            value: '7'
          }
        ],
        d_trade: '1',
        d_trade_data: [
          {
            label: '零售业',
            value: '1'
          },{
            label: '餐饮业',
            value: '2'
          },{
            label: '旅游业',
            value: '3'
          },{
            label: '体育，娱乐业',
            value: '4'
          },{
            label: '服务业',
            value: '5'
          },{
            label: '金融业',
            value: '6'
          }
        ],
        d_size: '1',
        d_size_data: [
          {
            label: '大型商铺',
            value: '1'
          },{
            label: '中型商铺',
            value: '2'
          },{
            label: '小型商铺',
            value: '3'
          }
        ],
        d_use: '1',
        d_use_data: [
          {
            label: '民用',
            value: '1'
          },{
            label: '商用',
            value: '2'
          }
        ]
      }
    },
    methods: {
      handleClick (name) {
        this.$router.push({
          name: 'noticeMain_page'
        })
      },
      search(){

      }
    }
  }
</script>
